import { BetMultiple } from 'src/app/models/bet-multiple.interface';
import { Action } from '@ngrx/store';

export enum EBetMultipleActions {
  AddBetMultiple = '[BetMultiple] Add BetMultiple',
  PlaceBetMultiple = '[BetMultiple] Place BetMultiple',
  DelBetMultiple = '[BetMultiple] Del BetMultiple',
  InitBetMultiple = '[BetMultiple] Init BetMultiple'
}

export class AddBetMultiple implements Action {
  public readonly type = EBetMultipleActions.AddBetMultiple;
  constructor(public payload: BetMultiple) {}
}

export class PlaceBetMultiple implements Action {
  public readonly type = EBetMultipleActions.PlaceBetMultiple;
  constructor(public payload: BetMultiple) {}
}

export class DelBetMultiple implements Action {
  public readonly type = EBetMultipleActions.DelBetMultiple;
  constructor(public payload: BetMultiple) {}
}

export class InitBetMultiple implements Action {
  public readonly type = EBetMultipleActions.InitBetMultiple;
}

export type BetMultipleActions =
  | AddBetMultiple
  | PlaceBetMultiple
  | DelBetMultiple
  | InitBetMultiple;
